/**
 * Search Forms
 *
 * @module
 */

import { $$ } from '../../utilities/QuerySelectors.js';

/**
 * Toggle the visibility of the search box on search toggle click.
 *
 * The search toggle is only visible on narrow screens.
 *
 * @private
 * @return {void}
 */
function initSearchToggler() {
    const toggleVisibility = (el) => el.classList.toggle('visible');
    const searchBox = document.querySelector('.mega-header-search');
    const searchToggle = document.querySelector('.mega-toggle-search');

    if (!searchToggle || !searchBox) {
        return;
    }

    searchToggle.addEventListener('click', (e) => {
        e.preventDefault();
        toggleVisibility(searchBox);
    });
}

/**
 * Provide a strong signal to the user that they are going to a new page
 * when a ticker is selected in the Ticker Search component.
 *
 * @private
 * @param {HTMLElement} input
 * @return {void}
 */
function addTickerSearchLoadingState(input) {
    input.addEventListener('awesomplete-select', (e) => {
        // @ts-ignore: Awesomeplete event does have e.origin property.
        const li = e.origin;
        li.classList.add('selected');

        document.body.classList.add('redirecting');
    });
}

/**
 * Specialized query selector for search box inputs.
 *
 * @private
 * @return {HTMLElement[]}
 */
function selectSearchInputs() {
    // @ts-ignore: do not understand the error
    return $$('.search-form, .mega-search')
        .map((searchForm) => searchForm.querySelector('input[name="s"]'))
        .filter((input) => Boolean(input));
}

/**
 * Initialize search box improvements.
 *
 * 1. Show loading state when going to a ticker from Ticker Search.
 * 2. Enable search box toggling for mobile.
 *
 * @return {void}
 */
export function init() {
    selectSearchInputs().forEach((searchInput) => {
        // @ts-ignore: FOOL_FREESITE is in window
        searchInput.setAttribute('value', window.FOOL_FREESITE.searchTerm);
        searchInput.value = window.FOOL_FREESITE.searchTerm;
        addTickerSearchLoadingState(searchInput);
    });

    initSearchToggler();
}
